define('app/components/ractivejs.se.decorator.play.dragndrop',[

  'app/app.utils',

  'jquery',
  'jqueryUi'

], function (
  UTILS,
  _$,
  _jqUi
) {

  var LOG_LABEL = 'RDEC PLAY DRNGDRP'

  /**
   *
   * @version 1.4
   *
   * @param node
   * @param update
   * @param params
   * @param updateCb
   * @returns {{update: update, teardown: teardown}}
   * @constructor
   */



  var TEMPLATES = {
    DRAGNDROP: $(' <div class="row se_drag"> <div class="col-xs-6"> <div>&nbsp;</div> <div class="se_drag_container se_drag_from" data-columnes="1 column"> <!-- div class="se_level_item se_drag_item"> <div>A</div> </div --> </div> <div>&nbsp;</div> </div> <div class="col-xs-6"> <div id="se_drag_label_first">First label</div> <div class="se_drag_container se_drag_to" data-columnes="1 column"> <div class="se_level_item se_drag_item hidden"></div> </div> <div id="se_drag_label_last">Last label</div> </div> </div>'),
    DRAGITEM: $('<div class="se_level_item se_drag_item" data-row-id><div></div></div>'),
    STYLES: $('' +
      '<style>' +
      '   .se_drag_hidden         { display: none !important; } ' +
      '   .se_drag_container      { min-height: 100px; background: rgba(255,255,255,.2); border: 1px solid rgba(102,102,102,.4); } ' +
      '   .se_drag_item, ' +
      '   .se_drag_placeholder    { min-height: 50px; padding: .25em; border: 1px solid rgba(102,102,102,.4); cursor: pointer;} ' +
      '   .se_drag_placeholder    { border: 1px dotted #f90; background: rgb(255, 201, 130); } ' +
      '   .se_drag_container .se_drag_item:nth-child(2n)      { background-color: rgba(0, 0, 0, .04); } ' +
      '   .se_drag_container .se_drag_item:nth-child(2n + 1)  { background-color: rgba(255,255,255,.2); } ' +
      '   .se_drag_item:hover     { background: #fd9 !important; } ' +
      '   .se_drag_item.ui-sortable-helper { background: #f90 !important; opacity: 0.7; } ' +
      '   @media screen and (max-width: 650px) {' +
      '    .se_drag_item,' +
      '    .se_drag_placeholder {' +
      '      padding: 0.25em;' +
      '      font-size: .7em;' +
      '    }' +
      '    .se_drag_item .padding {' +
      '      padding: 4px;' +
      '    }' +
      '    .se_drag_item p {' +
      '      margin-bottom: .5em;' +
      '    }' +
      '    .se_drag_item p:last-of-type {' +
      '      margin-bottom: 0;' +
      '    }' +
      '    .se_drag> div:first-child {' +
      '      padding: 0 0.125em 0 0;' +
      '    }' +
      '    .se_drag> div:last-child {' +
      '      padding: 0 0 0 0.125em;' +
      '    }' +
      '  } ' +
      '</style> ')
  }

  var
    SeDragNDrop = function (params) {

      var v = {
        params: {
          debug: false,
          thisId: null,
          instruction_label: 'Drag the items from left to right in your own order',
          matrix: 'next'
        },
        elms: {
          dragItems: [],
          $dragndrop: null,
          $drag_from: null,
          $drag_to: null,
          $matrix: null

        },
        is_destroyed: false
      }

      function readParams (params) {
        params = params || {}
        for (var i in params) {
          v.params[i] = params[i]
        }
      }

      function createDragnDrop () {

        var
          $this = v.params.thisId ? $('#' + v.params.thisId).closest('.se_item') : null,
          $styles = TEMPLATES.STYLES.clone(),

          $drag = TEMPLATES.DRAGNDROP.clone(),
          $drag_from = $drag.find('.se_drag_from'),
          $drag_to = $drag.find('.se_drag_to'),

          $matrix, $matrixItm,
          $labels, $options

        if (v.params.thisId && (!$this || !$this.length)) {
          console.error(LOG_LABEL, 'item not found for id', v.params.thisId, v.params)
          return
        }

        v.elms.$drag_from = $drag_from
        v.elms.$drag_to = $drag_to

        if (v.params.matrix !== 'next') {
          $matrix = $(v.params.matrix)
          $matrixItm = $matrix.closest('.se_item')

        } else {
          if (!$this) {
            console.error(LOG_LABEL, 'item not found for id; cant use \'next\' for matrix', v.params.thisId, v.params)
            return
          }
          $matrixItm = $this.next()
        }

        if (!$matrixItm.length) {
          console.error(LOG_LABEL, 'matrix .se_item not found', v.params.matrix, v.params)
          return
        }

        $matrix = $matrixItm.find('.se_matrix')

        v.elms.$matrix = $matrix

        if ($this) {
          $this.hide()
        }

        if (v.params.debug !== true)
          $matrix.addClass('se_drag_hidden')

        $labels = $matrixItm.find('.se_matrix_header > div')
        $drag.find('#se_drag_label_first').html($labels.first().html())
        $drag.find('#se_drag_label_last').html($labels.last().html())

        $matrixItm
          .append($styles)
          .append($drag)

        $matrixItm.find('.se_instruction').text(v.params.instruction_label)

        $options = $matrixItm.find('.se_matrix .row:not(:first-child) > div:first-child')

        if (!$options.length) return

        var $dragItem, dragItems = []
        $options.each(function (i, elm) {
          var $dragItem = TEMPLATES.DRAGITEM.clone()

          $dragItem.attr('data-row-id', i)
          $dragItem.find(' > div').html($(elm).html())

          dragItems.push($dragItem)
          $drag_from.append($dragItem)
        })

        v.elms.dragItems = dragItems

        testMatrix()

        if (!dragItems.length)
          return

        UTILS.waitFor(function dragItemIsVisible () {
          return $(dragItems[0]).is(':visible')
        }).then(function () {
          setTimeout(function () {

            restoreState()

            setDragContainerHeight()

            v.elms.$dragndrop = $([$drag_from, $drag_to]).sortable({
              se_drag_item: '.se_drag_item ',
              forcePlaceholderSize: true,
              connectWith: '.se_drag_container',
              dropOnEmpty: true,
              placeholder: 'se_drag_placeholder',

              stop: function (ev, ui) {
                saveState(ev)
              }
            })

          }, 5)
        })

      }

      function setDragContainerHeight () {
        var dragItems = v.elms.dragItems,
          $dragItem = dragItems[0]

        UTILS.waitFor(function dragItemIsVisible () {
          return $dragItem.is(':visible')
        }).then(function () {
          setTimeout(function () {
            updateDragContainerHeight()
          }, 50)
        })

        var isResizing,
          delayedUpdate = function () {
            if (v.is_destroyed) {
              return $(window).off('resize', delayedUpdate)
            }
            clearTimeout(isResizing)
            isResizing = setTimeout(function () {
              updateDragContainerHeight()
            }, 100)
          }

        $(window).on('resize', delayedUpdate)
      }

      function updateDragContainerHeight () {
        var dragItems = v.elms.dragItems,
          $drag_from = v.elms.$drag_from,
          $drag_to = v.elms.$drag_to

        // this must be calculated because it is never for sure that the drag_from contains all
        // the options, e.g. on "prev" or after resize

        var borderWidth = (parseInt($drag_from.css('border-top-width')) || 0) + (parseInt($drag_from.css('border-bottom-width')) || 0),
          dragItemsHeight = dragItems.reduce(function (r, $dragItem) { return r + $dragItem.outerHeight() }, 0) + borderWidth

        $drag_from.css('height', dragItemsHeight)
        $drag_to.css('height', dragItemsHeight)
      }

      function selectRow (rowElm, pos) {
        var $rowElm = $(rowElm),
          input

        console.debug('SAVE', rowElm, pos)
        // unselect input in row
        if (typeof pos === 'undefined') {
          if ($rowElm.find('.se_level_item.se_selected').length) {
            $rowElm
              .find('.se_level_item.se_selected')
              .removeClass('se_selected')
              .find('input')[0].checked = false
          }

          return
        }

        // select new input
        var $newPos = $rowElm.find('.se_level_item').eq(pos)
        if (!$newPos.hasClass('se_selected')) {
          $newPos.addClass('se_selected')
          $newPos.find('input')[0].checked = true
        }

      }

      function testMatrix(){
        // expect matrix to have as > 0 levels

        var $rows = v.elms.$matrix.find('.row:not(:first-child)')
        if(!$rows.length || _hasOnlyOneEmptyElement($rows)){
          throw new Error('Expected matrix to have at least 1 question')
        }

        // expect matrix to have as many levels as answers
        var $answers = $($rows[0]).find('.se_level_item')
        if($answers.length !== $rows.length || _hasOnlyOneEmptyElement($answers)){
          var // if there is only 1 answer / level and it is empty then treat it as "none"
            rLength = _hasOnlyOneEmptyElement($rows) ? 'no' : $rows.length,
            aLength = _hasOnlyOneEmptyElement($answers) ? 'no' : $answers.length

          throw new Error('Expecting matrix to have as many levels as answers; found ' + rLength + ' questions but ' + aLength + ' answers' )
        }
      }

      function restoreState () {
        var $rows = v.elms.$matrix.find('.row:not(:first-child)'),
          moveRows = []

        $rows.each(function (i, elm) {
          var $row = $(elm),
            pos = (+$row.find('.se_level_item.se_selected').find('input').val() || 0) - 1

          if (pos !== -1) {
            moveRows[pos] = v.elms.$drag_from.find('.se_drag_item[data-row-id=' + i + ']')
          }
        })

        $(moveRows).each(function (i, elm) {
          $(elm).appendTo(v.elms.$drag_to)
        })
      }

      function saveState (ev) {
        console.debug('EV', ev)

        var $rows = v.elms.$matrix.find('.row:not(:first-child)')
        // de-select all
        $rows.each(function (i, elm) {
          selectRow(elm)
        })

        // read in order of rows
        setTimeout(function () {
          v.elms.$drag_to.find('.se_drag_item[data-row-id]').each(function (pos, elm) {
            var rowId = +$(elm).attr('data-row-id'),
              rowElm = $rows.eq(rowId)

            // and save each pos to matrix
            selectRow(rowElm, pos)
          })
        }, 100)

      }

      this.destroy = function () {
        if (v.is_destroyed) return
        v.is_destroyed = true

        if (v.elms.$dragndrop) {
          v.elms.$dragndrop.sortable('destroy')
        }
        v.elms = null

      }

      function validate () {}

      readParams(params)
      createDragnDrop()

    }

  var DecoratorPlayDragnDrop = function (node, label) {
    var _this = this

    label = label || 'Drag the items from left to right in your own order'

    try{
      var dragnDrop = new SeDragNDrop({
        matrix: node,
        instruction_label: label,
        debug: false
      })
    }catch(err){
      console.warn(err)
      var
        $nodeItem = $(node).closest('.se_item'),
        $alert = $('<div class="alert alert-danger"><h4>Error rendering DragnDrop</h4><p><code>' + err.message + '</code></p></div>')

      $nodeItem.append($alert)
      $nodeItem.find('.se_drag').hide();
    }

    return {
      update: function () {
      },
      teardown: function () {
        dragnDrop.destroy()
      }
    }
  }

  return DecoratorPlayDragnDrop

})


function _hasOnlyOneEmptyElement($list){
  return $list
    && $list.length === 1
    && $list.eq(0).text().trim() === ''
};
